'use strict';
import $ from 'jquery';

export default class Vimeo {
    static init() {
        $('[data-vimeo-id]').each((index, el) => {
            new Vimeo($(el));
        });
    }

    constructor($el) {
        this.el = $el;
        this.resizeIframe();
        $(window).on('resize', this.resizeIframe.bind(this));
    }

    resizeIframe() {
        const self = this;
        setTimeout(() => {
            self.el.find('iframe').attr("width", self.el.width());
        }, 500);
    }
}